import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { environment } from '../../../environments/environment';
import RenderRoutes from './components/helpers/routes';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import { routes } from './routes/router';
import Loading from '@components/Loading';
import usePlatformInfo from '@customHooks/use-platform-info';
import SystemContext, { ISystemContext } from '@contexts/system-context';
import VersionModal from '@components/VersionModal/version-modal';

/**
 * App main component
 * @return App main component
 */
function App() 
{
  const { info } = usePlatformInfo();

  useEffect(() => {
    document.title = environment.env ? environment.env : 'Operational System';
  });

  const systemContextData: ISystemContext = {
    systemVersion: info?.version || null
  };

  return (
    <BrowserRouter>
      <ScrollToTop />
      <ToastContainer />
      <SystemContext.Provider value={ systemContextData }>
        <VersionModal/>
        <React.Suspense fallback={<Loading />}>
          <RenderRoutes routes={routes} />
        </React.Suspense>
      </SystemContext.Provider>
    </BrowserRouter>
  );
}

export default App;
